module.exports = __webpack_public_path__ + "media/images/countryrect/ss-d8050a37dc0a0063fdfb420ffd4dd565.svg";